import { useNavigate } from "react-router-dom";
import AppRoutes from "./components/shared/AppRoutes";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import { useEffect, useLayoutEffect } from "react";
import { resetState } from "./AppState/resetStateActions";
import { useDispatch } from "react-redux";
import Notification from "./components/shared/Notification";
import { useOktaAuth } from "@okta/okta-react";
import { initAxiosAuthInterceptors } from "./API/axiosAuthInterceptors";

const RootApp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { oktaAuth } = useOktaAuth();

  // useLayoutEffect runs earlier than useEffect in the commit phase.
  useLayoutEffect(() => {
    initAxiosAuthInterceptors(oktaAuth as any, dispatch, navigate);
  }, [oktaAuth, dispatch, navigate]);

  const resetProperties = () => {
    dispatch(resetState("SOFT_RESET"));
  };

  useEffect(() => {
    resetProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <Header />
      <AppRoutes />
      <Footer />
      <Notification />
    </div>
  );
};

export default RootApp;
